export const environment = {
  isMainnet: true,
  production: false,
  testFeatureRoutes: ['vip'],
  bsc: {
    chainId: "0x38", //hexadecimal for metamask
    chainIdInt: 56,
    chainName: "BSC Mainnet",
    gasFees: 0.0025,
    purchaseToken: "BNB",
    presaleAddress: "0xFB071837728455c581f370704b225ac9eABDfa4a",
    usdTAddress: "0x55d398326f99059fF775485246999027B3197955",
    rpcURL:
      "https://alien-radial-breeze.bsc.quiknode.pro/51ad95de67e584b29edb9b8dd5e34113b5f14e8b/",
    backupRPC:
      "https://alien-radial-breeze.bsc.quiknode.pro/51ad95de67e584b29edb9b8dd5e34113b5f14e8b/",
    blockExplorerURL: "https://bscscan.com/tx/",
    chainInfo: {
      method: "wallet_addEthereumChain",
      params: [
        {
          chainId: "0x38",
          chainName: "BSC Mainnet",
          nativeCurrency: {
            name: "BNB",
            symbol: "BNB",
            decimals: 18,
          },
          rpcUrls: ["https://bsc-dataseed2.ninicoin.io/"],
          blockExplorerUrls: ["https://bscscan.com/"],
        },
      ],
    },
  },
  tokenAddress: "0x62694d43ccb9b64e76e38385d15e325c7712a735",
  tokenName: "WSM",
  iidDashFx: 981,
  urlDashFx:
    "https://p4bno4qlye.execute-api.eu-west-2.amazonaws.com/default/dashFxPresaleMiddlewareApi",
  wertOrigin: "https://widget.wert.io",
  partnerId: "01H1CF8CA0PBKR7AV1J2EQ12CW",
  wertUrl:
    "https://xdlbh53kv37c7pd7crwdzteheq0sgzis.lambda-url.eu-west-2.on.aws/",
  howToBuyListId: "39",
  howToBuyURL:
    "https://d72xseva3bymzzervdthdpq7hm0cizyw.lambda-url.eu-west-2.on.aws/",
  socketUrl: "wss://1forlrij03.execute-api.eu-west-2.amazonaws.com/dev",
  metadataApi:
    "https://ecgppk884i.execute-api.eu-west-2.amazonaws.com/dev/v1/api/rpc-transaction/wsm",
  referUrl:
    "https://badkjeh43jamucpemyeqd7v2oi0zjzrn.lambda-url.eu-west-2.on.aws/",
  web3clientId:
    "BCOqSQnhHw3kyqrYnDdlBmt7OcQ4Za6gJk8cLhUdZVp29a4zM9hx95pH-nI0Cv7pkoINs_T3m-4tvnmMTC6R8ek",
  googleClientId:
    "1042529275125-2lvsu6s8i3ie215g16gcbiea202vt51j.apps.googleusercontent.com",
  torusWalletId:
    "BM6i2TPI3wuvEWPyedalQQkBl7R4_9t-MKv-oodWUYMJD502uWOQw3qpGnkLm5ALLzEeHGT49qEfxX39ynY98aI",
  stakingAddress: "0x24835b03f24bC8766a01c6A508513a90B097d06f",
  apyCalcConst: "200000000",
  apiBase_Url: "https://d1doad7sss1eup.cloudfront.net/dashboard-service-api/v1/api/",
  bwUniversalLink: "https://best-wallet-dev.web.app",
  bwDeepLink: "bw-dev://app/connect?",
  bwApiUrl: "https://dev-api.bestwallet.com/presale-transactions",
  showBestWallet: true,
  walletConnectId: "09ebdc51e59baedfa3c41f71529fff9c",
  contactApi:
    "https://kd4z73i6y9.execute-api.eu-west-2.amazonaws.com/dev/vipContactSubmit",
  openSeaAPIKey: "656e5e9088f84142b2a1fe6a88cebac8",
  openSeaEndpoint: "https://api.opensea.io/api/v2/",
};
